import { render, staticRenderFns } from "./button1.vue?vue&type=template&id=76cb26ff&scoped=true"
import script from "./button1.vue?vue&type=script&lang=js"
export * from "./button1.vue?vue&type=script&lang=js"
import style0 from "./button1.vue?vue&type=style&index=0&id=76cb26ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb26ff",
  null
  
)

export default component.exports